const RTL_CHAR_RANGES = [
  /[\u0590-\u05FF]/, // Hebrew
  /[\u0600-\u06FF]/, // Arabic
  /[\u0750-\u077F]/, // Arabic Supplement
  /[\u08A0-\u08FF]/, // Arabic Extended-A
  /[\uFB50-\uFDFF]/, // Arabic Presentation Forms-A
  /[\uFE70-\uFEFF]/, // Arabic Presentation Forms-B
];

/**
 * Returns true when the supplied text contains enough RTL characters
 * to justify flipping the layout direction.
 */
export function isRtlText(text: string, threshold = 0.25): boolean {
  if (!text) return false;
  const rtlMatches = text.match(new RegExp(RTL_CHAR_RANGES.map((r) => r.source).join("|"), "g"));
  if (!rtlMatches) return false;
  const rtlRatio = rtlMatches.length / text.length;
  return rtlRatio >= threshold;
}












